<template>
	<Container>
		<div class="container">
			<p class="title">搜索<strong>“{{keys}}”</strong>共找到{{result.TotalCount}}種結果</p>
			<div class="tabs">
				<div class="tab" :class='{"active-tab":qw == "All"}' @click='qw = "All"'>全部({{result.TotalCount || 0}})</div>
				<div class="tab" :class='{"active-tab":qw == "Product"}' @click='qw = "Product"'>産品({{productsLength}})</div>
				<div class="tab" :class='{"active-tab":qw == "Article"}' @click='qw = "Article"'>其他({{articlesLength}})</div>
			</div>
			<loading v-if='loading'/>
			<div class="result" v-else>
				<template v-for='modular in result.Datas'>
					<template v-if='modular.Code == "Product" && (qw =="All" || qw == "Product")'>
						<p class="tab-name">{{modular.Title}}({{productsLength}})</p>
						<ul class="products" >
							<ProductCell :isRead='true' :marighLeft='1.5' :goodsWidth='goodsWidth' class='product' v-for='(item,i) in products' :product='item' :key="i" />
						</ul>
						<LoadMore v-lazyFunc='searchMoreProduct' v-if='productsLoading'/>
					</template>
					<template v-if='modular.Code == "Article" && (qw =="All" || qw == "Article")'>
						<p class="tab-name">{{modular.Title}}({{articlesLength}})</p>
						<div class="articles" >
							<div class="item" v-for='article in modular.Datas'>
								<p class="title">{{article.Title}}</p>
								<p class="datetime">{{article.ValidFrom | dateFormat}}</p>
								<p class="content">{{article.Content | noHTML}}</p>
								<a :href='article.Href' class="button-primary detail">{{article.Flag2 || '查看詳情'}}</a>
							</div>
							<LoadMore v-lazyFunc='searchMoreArticle' v-if='articlesLoading'/>
						</div>
					</template>
					
				</template>
			</div>
		</div>
		
	</Container>
</template>

<script>
	import ProductCell from '@/components/order/ProductCell'
	import loading from '@/components/order/loading'
	import {
		mapState,
		mapMutations,
		mapActions
	} from 'vuex'
	export default {
		data() {
			return {
				result:[],
				keys:'',
				qw:'All',
				articlePageIndex:1,
				productPageIndex:1,
				loading:true,
				articlesLoading:true,
				productsLoading:true,
				pageSize:10,
			}
		},
		created() {
			this.$nextTick(function() {
				this.initData()
			})
		},
		mounted() {

		},
		watch:{
			'$route'(value){
				let keys = value.query?.keys
				this.search(keys)
			},
		},
		mixins:[],
		components: {
			ProductCell,
			loading,
		},
		computed: {
			...mapState({
				productInfo: state => state.order.productInfo,
			}),
			productsLength(){
				return this.result?.Datas?.filter(item=>item.Code == 'Product')[0]?.TotalCount || 0;
			},
			articlesLength(){
				return this.result?.Datas?.filter(item=>item.Code == 'Article')[0]?.TotalCount || 0;
			},
			goodsWidth(){
				if (document.body.clientWidth <= 768) {
					return 45
				}
				return 18
			},
			products(){
				let showProducts = []
				let products = this.productInfo.value.map(item=>item.products).flatMap(item=>item)
				let searched = this.result?.Datas?.filter(item=>item.Code == 'Product')[0]?.Datas || []
				searched.forEach(item=>{
					for (let item1 of products) {
						if(item1.sku == item.Code) {
							showProducts.push(item1)
							break;
						}
					}
				})
				return showProducts
			}
		},
		methods: {
			...mapActions([
				'searchByKeysAction',
				'initProductAction',
				'initProductStock',
				'initWarehouseAction',
			]),
			async search(keys){
				this.keys = keys
				this.loading = true
				this.result = {}
				let response = await this.searchByKeysAction({
					keys:this.keys,
					QW:this.qw,
					startIndex:1,
					pageSize:this.pageSize,
					isCount:10,
				})
				this.result = response
				this.loading = false
				this.articlePageIndex = 1
				this.productPageIndex = 1
				this.productsLoading = true
				this.articlesLoading = true
			},
			async initData(){
				await this.initWarehouseAction();
				await this.initProductStock('501');
				await this.initProductAction();
				this.keys = this.$route.query?.keys
				this.loading = true
				let response = await this.searchByKeysAction({
					keys:this.keys,
					QW:'All',
					startIndex:1,
					pageSize:this.pageSize,
					isCount:10,
				})
				this.result = response
				this.loading = false
			},
			async searchMoreArticle(){
				this.articlePageIndex += this.pageSize;
				let response = await this.searchByKeysAction({
					keys:this.keys,
					QW:'Article',
					startIndex:this.articlePageIndex,
					pageSize:this.pageSize,
					isCount:0,
				})
				this.articlesLoading = false
				let articles = this.result.Datas?.filter(item=>item.Code == 'Article')[0]?.Datas
				let newArticles = response?.Datas[0]?.Datas || []
				articles = [...articles,...newArticles]
				this.result.Datas.filter(item=>item.Code == 'Article')[0].Datas = articles
				if (this.articlePageIndex  <= this.articlesLength) {
					setTimeout(()=>{
						this.articlesLoading = true
					}, 500)
				}
				
			},
			async searchMoreProduct(){
				this.productPageIndex += this.pageSize;
				let response = await this.searchByKeysAction({
					keys:this.keys,
					QW:'Product',
					startIndex:this.productPageIndex,
					pageSize:this.pageSize,
					isCount:0,
				})
				this.productsLoading = false
				let articles = this.result.Datas?.filter(item=>item.Code == 'Product')[0]?.Datas
				let newArticles = response?.Datas[0]?.Datas || []
				articles = [...articles,...newArticles]
				this.result.Datas.filter(item=>item.Code == 'Product')[0].Datas = articles
				if (this.productPageIndex <= this.productsLength) {
					setTimeout(()=>{
						this.productsLoading = true
					}, 500)
				}
				
			}
		},
	}
</script>

<style lang='scss' scoped>
	@import '@/style/common';
	@import '@/style/mixin';
	.container {
		width: 85%;
		margin: auto;
		padding-top:0;
	}
	.title {
		text-align: center;
		@include fontSize($font-size-20);
		margin:40px 0;
		font-weight: bold;
		strong {
			@include fontSize($font-size-24);
			padding: 0 10px;
			font-weight: normal;
		}
	}
	.tabs {
		display:flex;
		align-items: center;
		justify-content: space-around;
		border-bottom:1px solid #eee;
		.tab {
			@include fontSize($font-size-24);
			padding: 10px 20px;
			cursor: pointer;
		}
		.active-tab {
			border-bottom:1px solid $theme-color;
			color:$theme-color;
		}
	}
	.result {
		.tab-name {
			@include fontSize($font-size-20);
			margin: 20px 0;
		}
		.products {
			list-style: none;
			display:flex;
			align-items: center;
			flex-wrap: wrap;
			.product {
				margin-left: 10px;
			}
		}
		.articles {
			.item {
				margin:0 20px;
				border-bottom: 1px solid #eee;
				.title {
					color:$theme-color;
					@include fontSize($font-size-18);
					margin-bottom: 5px;
					text-align: left;
					font-weight: normal;
				}
				.datetime,.content {
					margin-bottom: 5px;
				}
				.datetime {
					// max-width: 100px;
				}
				.detail {
					display: inline-block;
					padding: 3px 10px;
					border-radius: 20px;
					margin-top: 20px;
					margin-bottom: 20px;
				}
			}
		}
	}
	@media (max-width: 768px){
		.container {
			width: 95%;
		}
	}
</style>